// Mapping centralizzato tra ID sensore frontend (in mock.js / SensorCard / SensorDetail)
// e nome del campo nel backend (raw_epochs).
// Il backend espone i nomi reali del dongle: heart_r, breath_r, temp, hum, temp_a, hum_a.
// La UI ha sempre usato i nomi "umani": heartRate, breathRate, mattressTemp, ...
// Questo modulo tiene la traduzione in un solo posto.

export const SENSOR_TO_BACKEND = {
  heartRate: "heart_r",
  breathRate: "breath_r",
  mattressTemp: "temp",
  mattressHumidity: "hum",
  roomTemp: "temp_a",
  roomHumidity: "hum_a",
};

export const BACKEND_TO_SENSOR = Object.fromEntries(
  Object.entries(SENSOR_TO_BACKEND).map(([k, v]) => [v, k])
);

// Mappa risposta /api/user/me/today (sensors: { heart_r: {min,max,avg,current,count}, ... })
// in oggetti UI-friendly per ogni sensore frontend.
export function backendTodayToSensors(todayResp) {
  if (!todayResp || !todayResp.has_data) return null;
  const out = {};
  const src = todayResp.sensors || {};
  for (const [feId, beKey] of Object.entries(SENSOR_TO_BACKEND)) {
    const agg = src[beKey] || {};
    out[feId] = {
      current: agg.current ?? null,
      min: agg.min ?? null,
      max: agg.max ?? null,
      avg: agg.avg ?? null,
      count: agg.count ?? 0,
    };
  }
  return out;
}

// Trasforma /today/series in array {t, time, value} compatibile con LineChart.
export function pointsToChartSeries(points = []) {
  return points.map((p, i) => {
    const d = new Date(p.ts_ms);
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    return { t: i, time: `${hh}:${mm}`, value: p.value };
  });
}

// Trasforma /stats?range=XX in array {t, label, value} per il sensore richiesto.
// `feId` è l'ID frontend (heartRate, mattressTemp, ...).
export function statsToSeries(statsResp, feId) {
  if (!statsResp || !Array.isArray(statsResp.days) || statsResp.days.length === 0) {
    return [];
  }
  const beKey = SENSOR_TO_BACKEND[feId];
  if (!beKey) return [];
  // Inverti ordine (le days arrivano dal più recente al più vecchio)
  const ordered = [...statsResp.days].reverse();
  return ordered
    .map((d, i) => {
      const v = (d.sensor_avgs && d.sensor_avgs[beKey]) ?? null;
      return v == null
        ? null
        : { t: i, label: d.day_label || d.date.slice(5), value: v };
    })
    .filter(Boolean);
}
